export default __webpack_public_path__ + "static/media/SchoolProject3.df2e0fc7.jpeg";